var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.isSelectAllOptionForFilter)?_c('span',[_vm._v("(Select All)")]):(_vm.isStopSale)?_c('span',{staticClass:"kachel-badge red stop-sale-badge",class:{ 'stop-sale-badge--compact': _vm.isCompact }},[_c('i',{staticClass:"fas fa-exclamation"})]):_c('span',[_vm._v("-")])])
}
var staticRenderFns = []

export { render, staticRenderFns }